import type { TranslationResource } from './en';

export const pt: TranslationResource = {
  title: 'AutoCut - Instalador',
  downloading: 'A transferir o AutoCut',
  downloadedTitle: 'O AutoCut foi transferido com sucesso !',
  closingCountdown: 'A fechar em {{count}} segundos',
  alreadyInstalledTitle: 'O AutoCut já está instalado',
  alreadyInstalledHelp:
    'O AutoCut funciona agora como aplicação de ambiente de trabalho. Pode desinstalar esta extensão na aplicação Creative Cloud.',
};
